import { render } from "./EisenhowerMatrix.vue?vue&type=template&id=23c0b76a&scoped=true&ts=true"
import script from "./EisenhowerMatrix.vue?vue&type=script&lang=ts"
export * from "./EisenhowerMatrix.vue?vue&type=script&lang=ts"

import "./EisenhowerMatrix.vue?vue&type=style&index=0&id=23c0b76a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23c0b76a"]])

export default __exports__